<div class="wait_graph">
  <div class="axes">
    <i class="material-icons">timeline</i>
    <div class="heavy_query">
      <mh-heavy-query *ngIf="isHeavyQuery" [index]="index" [messages]="messages"></mh-heavy-query>
    </div>
  </div>
</div>